// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable sonarjs/no-duplicate-string */

import {
  claimsScreen,
  configureProduct,
  crashScreen,
  deductiblesSelection,
  errorPage,
  icWorkflowAction,
  optionalProduct,
  quotationCompleted,
  quotationConfirmed,
} from './common-config';

const leasingFiltersCalculator = 'private-lease-insurance-calculator';

export const leasingFiltersTaggingEvents = {
  widgetLoaded: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: configureProduct,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: configureProduct,
    },
  },
  widgetClosed: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'close-calculator',
      label: '$insStepName',
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: '$insStepName',
    },
  },
  nextSuccess: {
    event: {
      name: 'componentevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'click-next',
      label: '$insStepName',
    },
  },
  nextFail: {
    event: {
      name: 'componentevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'error',
      label: '$insStepName',
    },
  },
  offersLoaded: {
    event: {
      name: 'inscalcevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: quotationCompleted,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '1',
      step: quotationCompleted,
    },
  },
  productsLoaded: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: optionalProduct,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: optionalProduct,
    },
  },
  optionProductAdded: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: 'add-option-$insProductName',
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: 'add-option-$insProductName',
    },
  },
  offerChosen: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: quotationConfirmed,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: quotationConfirmed,
    },
  },
  errorPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: errorPage,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '-1',
      step: errorPage,
    },
  },
  errorCrashScreen: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: crashScreen,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '-1',
      step: crashScreen,
    },
  },
  claimsPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: claimsScreen,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: claimsScreen,
    },
  },
  back: {
    event: {
      name: 'componentevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: '$insStepName',
    },
  },
  backClaimsPage: {
    event: {
      name: 'componentevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: claimsScreen,
    },
  },
  offerReadMore: {
    event: {
      name: 'componentevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'view-product-info-$insProductName',
    },
  },
  deductiblesLoaded: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: deductiblesSelection,
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: deductiblesSelection,
    },
  },
  deductibleChosen: {
    event: {
      name: 'workflowevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: icWorkflowAction,
      label: 'select-deductible-$insDeductibleName',
    },
    workflow: {
      name: leasingFiltersCalculator,
      conversion: '0',
      step: 'select-deductible-$insDeductibleName',
    },
  },
  sendEmail: {
    event: {
      name: 'ctaevent',
      componentName: leasingFiltersCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'send-email-$insProductName',
    },
  },
};
